import { gql } from "apollo-boost";

const UPDATE_INVOICE_PREFIX_NUMBER = gql`
  mutation updateInvoiceNumberPrefix($input: UpdateInvoiceNumberPrefixInput!) {
    updateInvoiceNumberPrefix(input: $input) {
      status
      data
      error
    }
  }
`;
export default UPDATE_INVOICE_PREFIX_NUMBER;
